import React from "react";
import { useState, useEffect } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.css";
import Sidebar from "../layout/Sidebar";
import AgentSidebar from "../layout/AgentSidebar";

const Loan = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [customers, setCustomers] = useState(false);
  const [schemes, setSchemes] = useState(false);
  const [errors, setErrors] = useState({});
  const [items, setItems] = useState([]);
  const [tabs, setTabs] = useState([]);
  const [activeTab, setActiveTab] = useState("");
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [accounts, setAccounts] = useState(false);
  const [isDataLoaded, setIsDataLoaded] = useState(false);
  const [accountDetails, setAccountDetails] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [setupData, setSetupData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const baseURL = process.env.REACT_APP_BASE_URL;
  const [touched, setTouched] = useState({
    customer_name: false,
    scheme_name: false,
    amount: false,
    start_date: false,
    emi_date: false,
    statuss: false,
    collectionagent_name: false,
  });
  const [formData, setFormData] = useState({
    customer_name: "",
    scheme_name: "",
    investor_name: "",
    collectionagent_name: "",
    amount: "",
    emi_amount: "",
    id: "",
    initial_profit: "",
    rem_amount: "",
    start_date: "",
    end_date: "",
    emi_date: "",
    loan_id: "",
    statuss: "",
    aadharno: "",
    areaname: "",
    duration: "",
    interval: "",
    collectionagent_id: "",
  });
  const role= sessionStorage.getItem("role");
  const SidebarComponent = role === "agent" ? AgentSidebar : Sidebar;

  const validateField = (name, value) => {
    let error = "";

    if (name === "customer_name" && !value) {
      error = "Required";
    }
    if (name === "scheme_name" && !value) {
      error = "Required";
    }
    if (name === "amount" && !value) {
      error = "Required";
    }
    if (name === "initial_profit" && !value) {
      error = "Required";
    }
    if (name === "start_date" && !value) {
      error = "Required";
    }

    if (name === "collectionagent_name" && !value) {
      error = "Required";
    }
    if (name === "emi_date" && !value) {
      error = "Required";
    }
    if (name === "end_date" && !value) {
      error = "Required";
    }
    return error;
  };

  const toggleModal = () => {
    setIsModalOpen(!isModalOpen);
    generateLoanId();
    setTouched({
      customer_name: false,
      scheme_name: false,
      amount: false,
      start_date: false,
      emi_date: false,
      statuss: false,
      collectionagent_name: false,
    });
    if (!isModalOpen && !isEditMode) {
      const emptyData = {
        customer_name: "",
        scheme_name: "",
        investor_name: "",
        collectionagent_name: "",
        amount: "",
        emi_amount: "",
        id: "",
        initial_profit: "",
        rem_amount: "",
        start_date: "",
        end_date: "",
        emi_date: "",
        loan_id: "",
        statuss: "",
        aadharno: "",
        areaname: "",
        duration: "",
        interval: "",
        collectionagent_id: "",
      };

      setFormData(emptyData);
      setErrors({});
    }
  };



  const handleDropdownClick = async () => {
    try {
      const accessToken = sessionStorage.getItem("access_token");
      const response = await axios.get(`${baseURL}/getAllCustomer`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });
      setCustomers(response.data);
      console.log("Customers fetched successfully:", response.data);
    } catch (error) {
      console.error("Error fetching customers:", error);
    }
  };

  const handleSchemeDropdown = async () => {
    try {
      const accessToken = sessionStorage.getItem("access_token");
      const response = await axios.get(`${baseURL}/getAllScheme`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });
      setSchemes(response.data);
      console.log("Schemes fetched successfully:", response.data);
    } catch (error) {
      console.error("Error fetching schemes:", error);
    }
  };

  const handleAgentDropdown = async () => {
    try {
      const accessToken = sessionStorage.getItem("access_token");
      const response = await axios.get(`${baseURL}/getAllAccount`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });
      setAccounts(response.data);
      console.log("Agents fetched successfully:", response.data);
    } catch (error) {
      console.error("Error fetching agents:", error);
    }
  };

  const handleCustomerChange = async (e) => {
    const selectedCustomer = e.target.value;

    setErrors((prevErrors) => ({
      ...prevErrors,
      customer_name: validateField("customer_name", selectedCustomer),
    }));

    const selectedData = customers.find(
      (customer) => customer.id == selectedCustomer
    );

    if (selectedData) {
      console.log("Selected Customer:", selectedData);
      setFormData((prevData) => ({
        ...prevData,
        aadharno: selectedData.aadharno,
        areaname: selectedData.areaname,
        customer_name: selectedData.id,
      }));
    }
  };

  const groupTabsByName = (tabs) => {
    return tabs.reduce((acc, tab) => {
      if (!acc[tab.scheme_name]) {
        acc[tab.scheme_name] = [];
      }
      acc[tab.scheme_name].push(tab);
      return acc;
    }, {});
  };

  useEffect(() => {
    const accessToken = sessionStorage.getItem("access_token");
    axios
      .get(`${baseURL}/getScheme`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      })
      .then((response) => {
        const schemes = response.data;
        setTabs(schemes);
        if (schemes.length > 0 && !activeTab) {
          setActiveTab(schemes[0].scheme_name); // Set the default active tab
        }
      })
      .catch((error) => {
        console.error("Error fetching scheme data:", error);
      });
  }, []);

  useEffect(() => {
    if (tabs.length > 0 && !tabs.some((tab) => tab.scheme_name === activeTab)) {
      setActiveTab(tabs[0].scheme_name);
    }
    console.log("Tabs updated:", tabs);
    console.log("Active Tab:", activeTab);
  }, [tabs, activeTab]);

  useEffect(() => {
  if (role === "agent") {
    fetchAgentItems();
  } else {
    fetchItems();
  }

  const initialize = async () => {
    await fetchData();
  };
  initialize();
}, []);

  const handleTabClick = (schemeName) => {
    setActiveTab(schemeName);
  };

  useEffect(() => {
    const fetchSetupData = async () => {
      try {
        const accessToken = sessionStorage.getItem("access_token");


        const response = await axios.get(`${baseURL}/fetchSetup`, {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        });

        setSetupData(response.data);
      } catch (error) {
        console.error("Error fetching setup data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchSetupData();
  }, []);

  const updateData = (id) => {
    if (!isDataLoaded) {
      console.error("Data is not yet loaded. Please wait.");
      return;
    }

    const item = items.find((item) => item.id === id);
    if (!item) {
      console.error("Item not found for id:", id);
      return;
    }

    console.log(item);
    setFormData({
      customer_name: item.customer_id,
      scheme_name: item.scheme_id,
      amount: item.amount,
      initial_profit: item.initial_profit,
      emi_amount: item.emi_amount,
      rem_amount: item.rem_amount,
      start_date: item.start_date,
      end_date: item.end_date,
      emi_date: item.emi_date,

      loan_id: item.loan_id,

      statuss: item.statuss,
      id: item.id,
    });

    console.log(formData.customer_name);
    console.log(formData.scheme_name);
    console.log("Form Data : ", formData);

    console.log("Selected Customer ID:", item.customer_id);

    // Match customer
    console.log(item.customer_id);

    const selectedCustomer = customers.find(
      (customer) => customer.id == item.customer_id
    );
    console.log("Selected Dustomer: ", selectedCustomer);
    if (selectedCustomer) {
      setFormData((prevData) => ({
        ...prevData,
        aadharno: selectedCustomer.aadharno,
        areaname: selectedCustomer.areaname,
      }));
    } else {
      console.error(
        "No matching customer found for customer_id:",
        item.customer_id
      );
    }

    const selectedScheme = schemes.find(
      (scheme) => scheme.id == item.scheme_id
    );
    if (selectedScheme) {
      setFormData((prevData) => ({
        ...prevData,
        interval: selectedScheme.interval_detail,
        duration: selectedScheme.duration,
        value: selectedScheme.num,
      }));
    } else {
      console.error("No matching scheme found for scheme_id:", item.scheme_id);
    }

    console.log("Accounts Data:", accounts);
    console.log("Item Collection Agent ID:", item.collectionagent_id);
    console.log("Item Investor Name:", item.investor_id);

    // Match agent based on both conditions
    const selectedAgent = accounts.find(
      (account) =>
        account.admin_id == item.collectionagent_id &&
        account.investor_id == item.investor_name
    );

    console.log("Accounts Data:", accounts);
    console.log("Item Collection Agent ID:", item.collectionagent_id);
    console.log("Item Investor Name:", item.investor_name);

    console.log("Selected Agent : ", selectedAgent);

    if (selectedAgent) {
      setFormData((prevData) => ({
        ...prevData,

        investor_name: selectedAgent.acname,
        investor_id: selectedAgent.investor_id,
        collectionagent_name: selectedAgent.admin_id,
      }));
    } else {
      console.error(
        "No matching agent found for collectionagent_id:",
        item.collectionagent_id,
        "and investor_id:",
        item.investor_name
      );
    }

    setIsEditMode(true);
    setIsModalOpen(true);
  };

 useEffect(() => {
  console.log("Role:", role);
  if (role === "agent") {
    fetchAgentItems();
  } else {
    fetchItems();
  }
}, [activeTab]);


  const DynamicTabsFromDatabase = () => {
    const groupedTabs = groupTabsByName(tabs);

    return (
      <div className="container mx-auto p-4 bg-gray-50 w-auto">
        {/* Render Tabs */}
        <div className="flex overflow-x-auto border-b border-gray-300 mb-4 scrollbar-thin scrollbar-thumb-gray-400 scrollbar-track-gray-200">
          {Object.keys(groupedTabs).map((schemeName) => (
            <button
              key={schemeName}
              className={`px-4 py-2 whitespace-nowrap ${
                activeTab === schemeName
                  ? "text-blue-500 border-b-2 border-blue-500"
                  : "text-gray-500"
              }`}
              onClick={() => handleTabClick(schemeName)}
            >
              {schemeName}
            </button>
          ))}
        </div>

        {/* Search Bar */}
        <div className="mb-4 flex justify-center sm:justify-start">
          <input
            type="text"
            placeholder={`Search ${
              groupedTabs[activeTab]?.[0]?.scheme_name || ""
            }`}
            className="w-full sm:w-3/4 md:w-1/2 border border-gray-300 p-2 rounded text-sm sm:text-base focus:outline-none focus:border-blue-500"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
        </div>
      </div>
    );
  };

  const fetchData = async () => {
    try {
      console.log("Fetching dropdown data...");
      await Promise.all([
        handleDropdownClick(),
        handleSchemeDropdown(),
        handleAgentDropdown(),
      ]);
      setIsDataLoaded(true);
      console.log("Data loaded successfully");
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const handleEdit = async () => {
    console.log("Form Data before update:", formData);
    setIsSubmitted(true);
    const newErrors = {};
    for (const field in formData) {
      newErrors[field] = validateField(field, formData[field]);
    }

    setErrors(newErrors);

    if (Object.values(newErrors).some((error) => error)) {
      return;
    }
    try {
      const accessToken = sessionStorage.getItem("access_token");
      const response = await axios.put(`${baseURL}/updateLoan`, formData, {
        headers: {
          Authorization: `Bearer ${accessToken}`, // Add the access token here
        },
      });
      if (response.status === 200) {
        Swal.fire({
          icon: "success",
          text: "Loan updated successfully!",
          timer: 2000,
          showConfirmButton: false,
        });

        fetchItems();
        toggleModal();
        setIsEditMode(false);
      } else {
        console.error("Error updating Loan:", response.data);
      }
    } catch (error) {
      console.error("Error submitting form data:", error);
    }
  };

  const handleAgentChange = (e) => {
    const selectedAgentId = e.target.value;
    console.log("Selected Agent ID from Dropdown:", selectedAgentId);

    console.log("Accounts Data:", accounts);

    const selectedInvestor = accounts.find(
      (account) => account.admin_id == selectedAgentId
    );
    console.log("Selected Investor Object:", selectedInvestor);

    if (selectedInvestor) {
      setFormData((prevData) => {
        const updatedData = {
          ...prevData,
          collectionagent_id: selectedInvestor.collectionagent_id,
          investor_name: selectedInvestor.acname,
          investor_id: selectedInvestor.investor_name,
          collectionagent_name: selectedInvestor.admin_id,
        };
        console.log("Updated Form Data in State:", updatedData);
        return updatedData;
      });
    } else {
      console.error("No matching account found for ID:", selectedAgentId);
    }
  };

  const fetchItems = async () => {
    try {
      const accessToken = sessionStorage.getItem("access_token");
      const response = await axios.get(`${baseURL}/getAllLoan`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });
      setItems(response.data);
    } catch (error) {
      console.error("Error fetching items:", error);
    }
  };

   const fetchAgentItems = async () => {
    try {
      const accessToken = sessionStorage.getItem("access_token");
      const agentId = sessionStorage.getItem("agent_id");
      const response = await axios.get(`${baseURL}/getAgentLoans`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
        params: {
        agent_id: agentId, 
      },
      });
      setItems(response.data);
      console.log("Agent Loans fetched successfully:", response.data);
    } catch (error) {
      console.error("Error fetching items:", error);
    }
  };

  const handleSchemeChange = async (e) => {
    const selectedScheme = e.target.value;

    const selectedDuration = schemes.find(
      (scheme) => scheme.id == selectedScheme
    );

    if (selectedDuration) {
      console.log("Selected Scheme:", selectedDuration);
      setFormData((prevData) => ({
        ...prevData,
        scheme_name: selectedDuration.id,
        duration: selectedDuration.duration,
        interval: selectedDuration.interval_detail,
        value: selectedDuration.num,
      }));
    }
    setErrors((prevErrors) => ({
      ...prevErrors,
      scheme_name: validateField("scheme_name", selectedScheme),
    }));
  };
  const handleDelete = (item) => {
    Swal.fire({
      title: "Are you sure?",
      text: "Do you really want to delete this user?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "Cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        deleteItem(item.id);
        Swal.fire({
          icon: "success",
          title: "Deleted!",
          text: "The loan has been deleted.",
          timer: 2000,
          showConfirmButton: false,
        });
      }
    });
  };

  const deleteItem = async (id) => {
    try {
      const accessToken = sessionStorage.getItem("access_token");
      const response = await axios.delete(`${baseURL}/deleteLoan`, {
        data: { id: id },
        headers: {
          Authorization: `Bearer ${accessToken}`, // Add the access token here
        },
      });
      if (response.status === 200) {
        fetchItems();
      } else {
        Swal.fire({
          icon: "error",
          title: "Deletion Failed",

          timer: 3000,
          showConfirmButton: false,
        });
      }
    } catch (error) {
      console.error("Error deleting item:", error);
    }
  };

  const handleDateChange = (e) => {
    const { name, value } = e.target;

    setFormData((prevData) => {
      const updatedData = { ...prevData, [name]: value };

      if (
        name === "duration" ||
        name === "interval" ||
        name === "emi_date" ||
        name === "scheme_name"
      ) {
        updatedData.end_date = calculateEndDate(
          updatedData.emi_date,
          updatedData.interval,
          updatedData.duration
        );

        setErrors((prevErrors) => ({
          ...prevErrors,
          [name]: validateField(name, value),
        }));
      }

      return updatedData;
    });
  };

  const calculateEndDate = (emiDate, interval, duration) => {
    console.log("Calculating end date with emiDate:", emiDate, "interval:", interval, "duration:", duration);

    if (!emiDate || !interval || !duration) return "";

    try {
      const startDate = new Date(emiDate);
      const daysToAdd = parseInt(interval, 10) * parseInt(duration, 10);

      const endDate = new Date(startDate);
      endDate.setDate(endDate.getDate() + daysToAdd);

      return endDate.toISOString().split("T")[0];
    } catch (error) {
      console.error("Error calculating end date:", error);
      return "";
    }
  };

  const handleSubmit = async () => {
    setIsSubmitted(true);
    setTouched({
      customer_name: true,
      scheme_name: true,
      amount: true,
      start_date: true,
      emi_date: true,
      statuss: true,
      collectionagent_name: true,
    });
    console.log("Form submission started");
    const newErrors = {};
    for (const field in formData) {
      newErrors[field] = validateField(field, formData[field]);
    }
    console.log("Validation errors:", newErrors);
    setErrors(newErrors);

    if (Object.values(newErrors).some((error) => error)) {
      console.log("Form validation failed. Submission aborted.");
      return;
    }

    try {
      const accessToken = sessionStorage.getItem("access_token");
      const responses = await axios.post(`${baseURL}/insertLoan`, formData, {
        headers: {
          Authorization: `Bearer ${accessToken}`, // Add the access token here
        },
      });
      Swal.fire({
        icon: "success",
        text: "Loan added successfully!",
        timer: 2000,
        showConfirmButton: false,
      });

      toggleModal();
      fetchItems();
      const response = await axios.get(`${baseURL}/getScheme`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });
      setTabs(response.data);
    } catch (error) {
      console.error("Error submitting form data:", error);
    }
  };

  const generateLoanId = async () => {
    try {
      const accessToken = sessionStorage.getItem("access_token");
      const response = await axios.get(`${baseURL}/getLastLoanId`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });
      const lastLoanId = response.data.last_loan_id;

      if (!lastLoanId || typeof lastLoanId !== "string") {
        console.warn("Invalid or missing lastLoanId, defaulting to 'LON1'");
        setFormData((prevData) => ({
          ...prevData,
          loan_id: "LON1",
        }));
        return;
      }

      console.log(lastLoanId);

      const numericPart = parseInt(lastLoanId.replace("LON", ""), 10);
      const newLoanId = `LON${numericPart + 1}`;

      setFormData((prevData) => ({
        ...prevData,
        loan_id: newLoanId,
      }));
    } catch (error) {
      console.error("Error fetching last loan ID:", error);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
    setTouched((prevTouched) => ({
      ...prevTouched,
      [name]: true,
    }));

    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: validateField(name, value),
    }));
  };

  const handleAmountChange = (e) => {
    const value = e.target.value;
    const numericAmount = parseFloat(value);

    if (setupData && setupData.length > 0) {
      const initialProfit = parseFloat(setupData[0].initial_profit); 




      const calculatedProfit =
      !isNaN(numericAmount) && !isNaN(initialProfit)
        ? (numericAmount * (initialProfit / 100)).toFixed(2) 
        : "";

    setFormData((prevData) => ({
      ...prevData,
      amount: value,
      initial_profit: calculatedProfit,
      rem_amount: value,
    }));
  }
  };

  const handleEmiChange = (e) => {
    const { name, value } = e.target;

    setFormData((prevData) => {
      const updatedData = { ...prevData, [name]: value };

      if (name === "amount" || name === "duration" || name === "scheme_name") {
        const amount = parseFloat(updatedData.amount) || 0;
        const duration = parseInt(updatedData.duration, 10) || 0;
        updatedData.emi_amount =
          duration > 0 ? (amount / duration).toFixed(2) : "";
      }
      setErrors((prevErrors) => ({
        ...prevErrors,
        [name]: validateField(name, value),
      }));

      return updatedData;
    });
  };
  useEffect(() => {
  if (activeTab) {
    if (role === "agent") {
      fetchAgentItems();
    } else {
      fetchItems();
    }
  }
}, [activeTab, role]);

  const groupedTabs = groupTabsByName(tabs);

  useEffect(() => {
    if (tabs.length > 0 && !tabs.some((tab) => tab.scheme_name === activeTab)) {
      setActiveTab(tabs[0].scheme_name);
    }
  }, [tabs]);


  const filteredItems = items
  .filter((item) => item.scheme_name === activeTab) 
  .filter((item) => {
    const customerName = item.customer_name || '';
    const collectionAgentName = item.collectionagent_name || '';
    const amount = item.amount || '';
    const loanId = item.loan_id || '';

    return (
      customerName.toLowerCase().includes(searchQuery.toLowerCase()) ||
      collectionAgentName.toLowerCase().includes(searchQuery.toLowerCase()) ||
      amount.includes(searchQuery) ||
      loanId.includes(searchQuery)
    );
  });

  // Debugging activeTab and filtered items
  useEffect(() => {
    console.log("Active Tab:", activeTab);
    console.log("Filtered Items:", filteredItems);
  }, [activeTab, filteredItems]);

  const filteredItem = items.filter((item) => {
    const customerName = item.customer_name || '';
    const collectionAgentName = item.collectionagent_name || '';
    const amount = item.amount || '';
    const loanId = item.loan_id || '';
  
    return (
      customerName.toLowerCase().includes(searchQuery.toLowerCase()) ||
      collectionAgentName.toLowerCase().includes(searchQuery.toLowerCase()) ||
      amount.includes(searchQuery) ||
      loanId.includes(searchQuery)
    );
  });
  

  return (
    <div className="bg-gray-100 flex flex-col w-full">
      <SidebarComponent />
      <main className="flex-grow p-6 w-full">
        <h2 className="text-3xl font-bold text-center mt-5">Loan</h2>

        <div className="mt-6 bg-white shadow rounded-lg p-4 ml-0 sm:ml-0 md:ml-28 lg:ml-64">
          <div className="flex overflow-x-auto border-b border-gray-300 mb-4 scrollbar-thin scrollbar-thumb-gray-400 scrollbar-track-gray-200">
            {Object.keys(groupedTabs).map((schemeName) => (
              <button
                key={schemeName}
                className={`px-4 py-2 whitespace-nowrap ${
                  activeTab === schemeName
                    ? "text-blue-500 border-b-2 border-blue-500"
                    : "text-gray-500"
                }`}
                onClick={() => handleTabClick(schemeName)}
              >
                {schemeName}
              </button>
            ))}
          </div>
          {/* Search Bar */}
          <div className="mb-4 flex justify-center sm:justify-start">
            <input
              type="text"
              placeholder={`Search ${
                groupedTabs[activeTab]?.[0]?.scheme_name || ""
              }`}
              className="w-full sm:w-3/4 md:w-1/2 border border-gray-300 p-2 rounded text-sm sm:text-base focus:outline-none focus:border-blue-500"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
            {role !== "agent" && (
  <button
    onClick={() => {
      setIsEditMode(false);
      toggleModal();
    }}
    className="bg-green-500 text-white px-4 py-2 rounded ml-4"
  >
    Add Loan
  </button>
)}

          </div>

          <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center space-y-4 sm:space-y-0 mb-4">
            <div className="flex items-center space-x-2">
              {/* Table */}

              {isModalOpen && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                  <div className="relative w-full sm:w-full md:w-1/2 max-h-[70vh] overflow-y-auto bg-white rounded-lg p-4 top-12 sm:top-16 md:top-24">
                    <div className="flex justify-between items-center mb-4">
                      <h2 className="text-lg md:text-xl font-semibold">
                        {isEditMode ? "Update Loan" : "Add  Loan"}
                      </h2>
                      <button
                        onClick={() => {
                          setIsEditMode(false);
                          toggleModal();
                        }}
                        className="text-gray-600 text-2xl"
                      >
                        &times;
                      </button>
                    </div>
                    <form className="space-y-4">
                      <div className="flex flex-col items-center mb-6"></div>
                      <div className="grid grid-cols-2 gap-4">
                        <div>
                          <label className="block text-gray-600">
                            Customer Name  <span className="text-red-500">*</span>
                          </label>
                          <select
                            type="text"
                            name="customer_name"
                            value={formData.customer_name || ""}
                            onClick={handleDropdownClick}
                            onChange={handleCustomerChange}
                            className={`border p-2 w-full ${
                              errors.customer_name && touched.customer_name
                                ? "border-red-500"
                                : "border-gray-300"
                            }`}
                          >
                            <option value="Select a Customer">Select a customer</option>
                            {customers.length > 0 ? (
                              customers.map((customer) => (
                                <option
                                  key={customer.customername}
                                  value={customer.id}
                                >
                                  {customer.customername}
                                </option>
                              ))
                            ) : (
                              <option disabled>No values available</option>
                            )}
                          </select>
                          {errors.customer_name && touched.customer_name && (
                            <span className="text-red-500 text-sm">
                              {errors.customer_name}
                            </span>
                          )}
                        </div>
                        <div>
                          <label className="block text-gray-600">
                            Aadhar No.
                          </label>
                          <input
                            type="text"
                            name="aadharno"
                            value={formData.aadharno || ""}
                            className="border border-gray-300 rounded w-full p-2"
                          />
                        </div>
                        <div>
                          <label className="block text-gray-600">
                            Area Name
                          </label>
                          <input
                            type="text"
                            name="areaname"
                            value={formData.areaname || ""}
                            className="border border-gray-300 rounded w-full p-2"
                          />
                        </div>
                        <div>
                          <label className="block text-gray-600">
                            Scheme Name  <span className="text-red-500">*</span>
                          </label>
                          <select
                            type="text"
                            name="scheme_name"
                            value={formData.scheme_name || " "}
                            onClick={handleSchemeDropdown}
                            onChange={(e) => {
                              handleSchemeChange(e);
                              handleDateChange(e);
                              handleEmiChange(e);
                            }}
                            className={`border p-2 w-full ${
                              errors.scheme_name && touched.scheme_name
                                ? "border-red-500"
                                : "border-gray-300"
                            }`}
                          >
                            <option value="">Select the scheme</option>

                            {schemes.length > 0 ? (
                              schemes.map((scheme) => (
                                <option
                                  key={scheme.scheme_name}
                                  value={scheme.id}
                                >
                                  {scheme.scheme_name}
                                </option>
                              ))
                            ) : (
                              <option disabled>No values available</option>
                            )}
                          </select>
                          {errors.scheme_name && touched.scheme_name && (
                            <span className="text-red-500 text-sm">
                              {errors.scheme_name}
                            </span>
                          )}
                        </div>
                        <div>
                          <label className="block text-gray-600">
                            Duration <span className="text-red-500">*</span>
                          </label>
                          <input
                            name="duration"
                            value={formData.duration || ""}
                            onChange={handleEmiChange}
                            className="border border-gray-300 rounded w-full p-2"
                          />
                        </div>
                        <div>
                          <label className="block text-gray-600">
                            Interval  <span className="text-red-500">*</span>
                          </label>
                          <input
                            name="interval"
                            value={formData.interval || ""}
                            className="border border-gray-300 rounded w-full p-2"
                          />
                        </div>
                        <div>
                          <label className="block text-gray-600">Value  <span className="text-red-500">*</span></label>
                          <input
                            name="value"
                            value={formData.value || ""}
                            className="border border-gray-300 rounded w-full p-2"
                          />
                        </div>
                        <div>
                          <label className="block text-gray-600">Amount  <span className="text-red-500">*</span></label>
                          <input
                            type="number"
                            name="amount"
                            value={formData.amount || ""}
                            onChange={(e) => {
                              handleEmiChange(e);
                              handleAmountChange(e);
                            }}
                            className={`border p-2 w-full ${
                              errors.amount && touched.amount
                                ? "border-red-500"
                                : "border-gray-300"
                            }`}
                          />
                          {errors.amount && touched.amount && (
                            <span className="text-red-500 text-sm">
                              {errors.amount}
                            </span>
                          )}
                        </div>

                        <div>
                          <label className="block text-gray-600">
                            Initial Profit  <span className="text-red-500">*</span>
                          </label>
                          <input
                            type="text"
                            name="initial_profit"
                            value={formData.initial_profit || ""}
                            readOnly
                            className={`border p-2 w-full ${
                              errors.initial_profit && touched.initial_profit
                                ? "border-red-500"
                                : "border-gray-300"
                            }`}
                          />
                          {errors.initial_profit && touched.initial_profit && (
                            <span className="text-red-500 text-sm">
                              {errors.initial_profit}
                            </span>
                          )}
                        </div>
                        <div>
                          <label className="block text-gray-600">EMI</label>
                          <input
                            type="text"
                            name="emi_amount"
                            value={formData.emi_amount || ""}
                            readOnly
                            className="border border-gray-300 rounded w-full p-2"
                          />
                        </div>
                        <div>
                          <label className="block text-gray-600">
                            Start date  <span className="text-red-500">*</span>
                          </label>
                          <input
                            type="date"
                            name="start_date"
                            value={formData.start_date || ""}
                            onChange={handleInputChange}
                            className={`border p-2 w-full ${
                              errors.start_date && touched.start_date
                                ? "border-red-500"
                                : "border-gray-300"
                            }`}
                          />
                          {errors.start_date && touched.start_date && (
                            <span className="text-red-500 text-sm">
                              {errors.start_date}
                            </span>
                          )}
                        </div>

                        <div>
                          <label className="block text-gray-600">Loan ID</label>
                          <input
                            type="text"
                            name="loan_id"
                            value={formData.loan_id || ""}
                            className="border border-gray-300 rounded w-full p-2"
                          />
                        </div>

                        <div>
                          <label className="block text-gray-600">
                            Agent Name  <span className="text-red-500">*</span>
                          </label>
                          <select
                            name="collectionagent_name"
                            value={formData.collectionagent_name || ""}
                            onClick={handleAgentDropdown}
                            onChange={(e) => {
                              handleAgentChange(e);
                              handleInputChange(e);
                            }}
                           
                            className={`border p-2 w-full ${
                              errors.collectionagent_name &&
                              touched.collectionagent_name
                                ? "border-red-500"
                                : "border-gray-300"
                            }`}
                          >
                            <option value="" disabled selected>Select the agent</option>
                            {accounts.length > 0 ? (
                              accounts.map((account) => (
                                <option
                                  key={account.admin_id}
                                  value={account.admin_id}
                                >
                                  {account.admin_name}
                                </option>
                              ))
                            ) : (
                              <option disabled>No values available</option>
                            )}
                          </select>
                          {errors.collectionagent_name &&
                            touched.collectionagent_name && (
                              <span className="text-red-500 text-sm">
                                {errors.collectionagent_name}
                              </span>
                            )}
                        </div>
                        <div>
                          <label className="block text-gray-600">
                            Investor Name  <span className="text-red-500">*</span>
                          </label>
                          <input
                            name="investor_name"
                            value={formData.investor_name || " "}
                            className="border border-gray-300 rounded w-full p-2 focus:outline-none focus:ring-2 focus:ring-blue-200 focus:border-blue-400 "
                          />
                        </div>
                        <div>
                          <label className="block text-gray-600">
                            EMI Date  <span className="text-red-500">*</span>
                          </label>
                          <input
                            type="date"
                            name="emi_date"
                            value={formData.emi_date || ""}
                            onChange={handleDateChange}
                            className={`border p-2 w-full ${
                              errors.emi_date && touched.emi_date
                                ? "border-red-500"
                                : "border-gray-300"
                            }`}
                          />
                          {errors.emi_date && touched.emi_date && (
                            <span className="text-red-500 text-sm">
                              {errors.emi_date}
                            </span>
                          )}
                        </div>
                        <div>
                          <label className="block text-gray-600">
                            End Date  <span className="text-red-500">*</span>
                          </label>
                          <input
                            type="date"
                            name="end_date"
                            value={formData.end_date || ""}
                            onChange={handleInputChange}
                            className="border border-gray-300 rounded w-full p-2 focus:outline-none focus:ring-2 focus:ring-blue-200 focus:border-blue-400 "
                          />
                        </div>
                        {isEditMode && (
                          <div>
                            <label className="block text-gray-600">
                              Status
                            </label>
                            <select
                              name="statuss"
                              value={formData.statuss || ""}
                              onChange={handleInputChange}
                              className="border p-2 w-full border-gray-300"
                            >
                              <option>Mark the status</option>
                              <option>Active</option>
                              <option>Inactive</option>
                            </select>
                          </div>
                        )}
                        
                      </div>
                      <div className="flex justify-end mt-4 space-x-2">
                       
                        <button
                          type="button"
                          onClick={() => {
                            toggleModal();
                            setIsEditMode(false);
                          }}
                          className="bg-gray-300 text-gray-700 px-4 py-2 rounded hover:bg-gray-400"
                        >
                          Close
                        </button>
                        <button
                          onClick={() => {
                            if (isEditMode) {
                              handleEdit();
                            } else {
                              handleSubmit();
                              setIsEditMode(false);
                            }
                          }}
                          type="button"
                          className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
                        >
                          {isEditMode ? "Update" : "Submit"}
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              )}
            </div>

            <div className="container mx-auto p-4 bg-gray-50">
              {/* Table */}
              <div className="flex flex-col h-screen">
                <div className="overflow-x-auto">
                 <table className="w-full text-left border-collapse text-sm sm:text-xs md:text-sm lg:text-base">
  <thead className="bg-gray-100">
    <tr>
      <th className="p-2 border border-gray-300 text-left">Id</th>
      <th className="p-2 border border-gray-300 text-left">Loan ID</th>
      <th className="p-2 border border-gray-300 text-left">Customer Name</th>
      <th className="p-2 border border-gray-300 text-left">Amount</th>
      <th className="p-2 border border-gray-300 text-left">Admin</th>
      <th className="p-2 border border-gray-300 text-left">Status</th>
      {role !== "agent" && (
        <th className="p-2 border border-gray-300 text-left">Options</th>
      )}
    </tr>
  </thead>
  <tbody>
    {filteredItems.map((item) => (
      <tr key={item.id} className="border-b hover:bg-gray-50">
        <td className="p-2">{item.id}</td>
        <td className="p-2">{item.loan_id}</td>
        <td className="p-2">{item.customer_name}</td>
        <td className="p-2">{item.amount}</td>
        <td className="p-2">{item.collectionagent_name}</td>
        <td className="p-2">{item.statuss}</td>
        {role !== "agent" && (
          <td className="p-2 space-x-3">
            <button
              onClick={() => updateData(item.id)}
              className="text-blue-500"
            >
              <i className="fas fa-edit"></i>
            </button>
            <button
              onClick={() => handleDelete(item)}
              className="text-red-500"
            >
              <i className="fas fa-trash"></i>
            </button>
          </td>
        )}
      </tr>
    ))}
  </tbody>
</table>

                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default Loan;
